import { createAction } from '@reduxjs/toolkit';
import { DeviceType } from '@wix/cashier-common/dist/src/enums/DeviceType';

export const setDeviceType = createAction<DeviceType, 'SET_DEVICE_TYPE'>('SET_DEVICE_TYPE');
